/**
 * Send an anonymous onboarding visitor to sign in: the app root triggers the
 * panel's own sign-in redirect. No identity provider needs to be initialized
 * for this (the public tree skips that boot).
 */

import { appBase } from './publicRoutes';

export function signInHref(): string {
  return `${appBase()}/` || '/';
}

export function goToSignIn(): void {
  window.location.href = signInHref();
}
